<template>
  <div class="user-header">
    <div v-if="$route.name === 'Home'" class="search-house-input">
      <div class="input-with-cross">
        <input id="search-input" :value="searchInput" @keyup="searchInput = $event.target.value" type="text"
               class="form-control home-search" placeholder="Поиск дома">
        <span v-if="searchInput" class="ic-cross" @click="searchInput = ''"></span>
        <label for="search-input" class="search-logo ic-search"></label>
      </div>
    </div>

    <div class="user-info" :class="{'user-info--full-page': $route.name !== 'Home'}">
      <span v-if="username" class="user-header-name">{{ username }}</span>
      <div class="user-header-photo"><span class="ic-user-default"></span></div>
    </div>

  </div>

</template>

<script>

import {useStore} from "vuex";
import {computed} from "vue";
import {useRouter} from "vue-router";

export default {
  name: "UserHeader",
  setup() {
    const store = useStore(),
      router = useRouter()

    const searchInput = computed({
      get: () => store.state.housesList.searchInput,
      set: newVal => {
        if (newVal) {
          router.replace({name: 'Home', query: {search: newVal}})
        } else {
          router.replace({name: 'Home'})
        }
        store.commit("housesList/setCurrentPage", 1)
        store.dispatch('housesList/searchHouses', newVal)
      }
    })

    return {
      searchInput,
      username: store.getters["user/getUsername"]
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.user-header {
  width: 100%;
  height: 60px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  max-width: 1280px;

  .user-info {
    display: flex;
    flex-direction: row;

    &--full-page {
      flex-wrap: nowrap;
      align-items: center;
      width: 100%;
      justify-content: space-between;
    }

    .user-header-name {
      height: 100%;
      background: var(--common-background-shape);
      border-radius: 20px;
      padding: .8rem;
      line-height: 100%;
      display: flex;
      align-items: center;
      margin-right: 1rem;
      box-shadow: var(--common-content-box-shadow);
    }

    .user-header-photo {
      width: 60px;
      height: 60px;
      background: var(--common-background-shape);
      border-radius: 50%;
      box-shadow: var(--common-content-box-shadow);
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 30px;

        &:hover {
          color: var(--default-icon-color);
        }
      }
    }
  }

  .search-house-input {
    display: flex;
    align-items: stretch;

    .input-with-cross {
      position: relative;
      width: 100%;
      display: flex;
      align-items: stretch;

      input {
        padding: 0 60px;
        background: var(--common-background-shape);
        border: none;
        box-shadow: var(--common-content-box-shadow);
      }

      span, label {
        position: absolute;
        height: 100%;
        top: 0;
        display: flex;
        align-items: center;

        &.ic-cross {
          right: 25px;
          cursor: pointer;
        }

        &.ic-search {
          left: 25px;

          &:hover {
           color: var(--default-icon-color);
          }
        }
      }
    }
  }


}


</style>
